import React, { useContext } from 'react';
import {
    Container,
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Alert
} from '@mui/material';
import {
    Cancel as CancelIcon,
    ArrowBack as ArrowBackIcon,
    ContactSupport as ContactSupportIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { messageContext } from '../../stores/messages/messageContext';

const SubscriptionCancel = () => {
    const navigate = useNavigate();
    const messageStore = useContext(messageContext);

    const handleBackToPlans = () => {
        navigate('/subscription/');
    };

    const handleContactSupport = () => {
        navigate('/contact/');
    };

    const handleTryAgain = () => {
        messageStore.setMessage('Ready to try again? Choose your perfect plan!', 'info');
        navigate('/subscription/');
    };

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Card sx={{ textAlign: 'center', p: 4 }}>
                <CardContent>
                    <CancelIcon
                        sx={{
                            fontSize: 80,
                            color: 'warning.main',
                            mb: 2
                        }}
                    />

                    <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
                        Subscription Cancelled
                    </Typography>

                    <Typography variant="h6" color="text.secondary" paragraph>
                        No worries! Your subscription process was cancelled.
                    </Typography>

                    <Alert severity="info" sx={{ my: 4, textAlign: 'left' }}>
                        <Typography variant="body2">
                            <strong>What happened?</strong><br />
                            You cancelled the subscription process before completing payment.
                            No charges have been made to your account.
                        </Typography>
                    </Alert>

                    <Typography variant="body1" paragraph sx={{ mb: 4 }}>
                        You can still access our free plan features, or upgrade to a premium plan
                        at any time to unlock unlimited transcriptions and advanced features.
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleTryAgain}
                            sx={{ py: 1.5 }}
                        >
                            Try Again
                        </Button>

                        <Button
                            variant="outlined"
                            size="large"
                            startIcon={<ContactSupportIcon />}
                            onClick={handleContactSupport}
                            sx={{ py: 1.5 }}
                        >
                            Contact Support
                        </Button>
                    </Box>

                    <Box sx={{ mt: 4, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
                        <Typography variant="body2" color="text.secondary" paragraph>
                            <strong>Free Plan Features:</strong>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            • 1 GB of storage<br />
                            • 2 hours of transcriptions per month<br />
                            • Basic export formats<br />
                            • Community support
                        </Typography>
                    </Box>

                    <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
                        Questions about our plans?{' '}
                        <Button variant="text" size="small" onClick={handleContactSupport}>
                            Get in touch with our team
                        </Button>
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
};

export default SubscriptionCancel; 